import { ButtonERP, PrimeReactModal } from "@finanedi.es/storybook"
import { MODAL_STYLES } from "constants/primereactStyles"
import { useTranslation } from "react-i18next"

interface ModalErroresImportacionToastProps {
  show: boolean
  onHide: () => void
  message: string[] | undefined
  title: string
}
const ModalVerErroresImportacionToast = ({
  show,
  onHide,
  message,
  title,
}: ModalErroresImportacionToastProps) => {
  const { t } = useTranslation()
  return (
    <PrimeReactModal
      visible={show}
      className='tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
      baseZIndex={30}
      ptContext={MODAL_STYLES}
      closable={false}
      headerClassName='!tw-text-xl'
      header={`${t("integracion.toast.modal.listErrorTitle")} ${title}`}
      footer={
        <div
          key='BotonesCierreExito'
          className='tw-flex tw-justify-end tw-items-center tw-mt-4'
        >
          <ButtonERP
            onClick={() => {
              onHide()
            }}
            label={`${t("integracion.toast.modal.close")}`}
            customize={{
              type: "white",
              size: "md",
            }}
          />
        </div>
      }
    >
      <section className='!tw-max-h-60 tw-overflow-y-auto'>
        <div className='tw-flex tw-flex-col '>
          {message?.map((mes: string, index: number) => (
            <span
              key={`${index + 1}-error`}
              className='!tw-text-sm tw-py-0.5'
            >
              {mes}
            </span>
          ))}
        </div>
      </section>
    </PrimeReactModal>
  )
}

export default ModalVerErroresImportacionToast
